module.exports = __webpack_public_path__ + "img/unsplash_VUOiQW4OeLIcover.18dde210.png";